import { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { GET_PDA_HOME_MENU_BASIC_CONFIG, GET_PDA_HOME_MENUS_BY_WAREHOUSE_ID } from '../graphql/queries';

export const usePdaMenuConfig = (warehouseId: number | null, role: string | null, isEditing: boolean = false) => {
  const [existingMenuIds, setExistingMenuIds] = useState<number[]>([]);

  // Always fetch basic config (no cache for fresh data)
  const { data: basicConfigData, loading: basicLoading, refetch: refetchBasicConfig } = useQuery(GET_PDA_HOME_MENU_BASIC_CONFIG, {
    fetchPolicy: 'network-only',
  });

  // Fetch existing menus (role and warehouseId are required)
  const shouldFetchExisting = !!role && warehouseId !== null;
  const { data: existingMenusData, loading: existingLoading } = useQuery(GET_PDA_HOME_MENUS_BY_WAREHOUSE_ID, {
    variables: {
      warehouseId: isEditing ? (warehouseId ?? 0) : 0,
      accountRole: role!,
    },
    skip: !shouldFetchExisting,
    fetchPolicy: 'network-only', // 禁用缓存，每次都从服务器获取最新数据
  });

  // Update existingMenuIds when editing config data is loaded
  useEffect(() => {
    if (shouldFetchExisting && existingMenusData?.getPdaHomeMenusByWarehouseId) {
      setExistingMenuIds(existingMenusData.getPdaHomeMenusByWarehouseId.menuConfigIds || []);
    } else {
      setExistingMenuIds([]);
    }
  }, [shouldFetchExisting, existingMenusData]);

  const menuConfig = basicConfigData?.getPdaHomeMenuBasicConfig || [];

  return {
    menuConfig,
    existingMenuIds,
    loading: basicLoading || (shouldFetchExisting && existingLoading),
    // 暴露给外部，用于图标替换后立即刷新菜单数据
    refetchMenuConfig: refetchBasicConfig,
  };
};
